const CDN = '//yaimg.yanolja.com/joy/sunny';
export const getSVG = (path: string = ''): string => {
  return CDN.concat(path);
};
